import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface PrivacyPolicyProps {
  onBack: () => void;
}

export const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="font-medium">Volver</span>
        </button>

        <article className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-black text-gray-900 mb-4">Política de Privacidad</h1>
          <p className="text-xl text-gray-600 mb-8">Política de Privacidad de programatuviaje.cl</p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Información recopilada</h2>
            <p className="text-gray-700 leading-relaxed">
              Recopilamos información básica del usuario (como nombre y correo electrónico) cuando se registra a través de proveedores externos como Google.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Uso de la información</h2>
            <p className="text-gray-700 leading-relaxed">
              Los datos se utilizan únicamente para el funcionamiento de la aplicación, permitir el acceso al usuario y mejorar la experiencia del servicio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Almacenamiento</h2>
            <p className="text-gray-700 leading-relaxed">
              La información se almacena en servidores seguros y solo se conserva mientras sea necesario para la prestación del servicio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Derechos del usuario</h2>
            <p className="text-gray-700 leading-relaxed">
              El usuario puede solicitar la eliminación de su cuenta y sus datos personales en cualquier momento escribiendo a nuestro correo de contacto: programatuviajeadm@gmail.com.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contacto</h2>
            <p className="text-gray-700 leading-relaxed">
              Para cualquier duda sobre esta política, puede escribirnos a programatuviajeadm@gmail.com.
            </p>
          </section>
        </article>
      </div>
    </div>
  );
};

